<template>
  <app-modal v-model="isDialogOpened"
             :cancel-text="$t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.cancelButtonLabel')"
             :ok-text="$t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.okButtonLabel')"
             size="md"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.dialogTitle') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.dialogBody") }}</p>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistPrepareCancelDialog',
  mixins: [dialogMixin],
  emits: ['confirm'],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
